import { render, staticRenderFns } from "./CalendarEventDetailsModal.vue?vue&type=template&id=7515c16b&scoped=true"
import script from "./CalendarEventDetailsModal.vue?vue&type=script&lang=js"
export * from "./CalendarEventDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7515c16b",
  null
  
)

export default component.exports